<template>
  <v-card
    v-if="activities.length"
    id="allActivities"
    width="100%"
    flat
    color="transparent"
  >
    <v-card-title class="px-0 py-2">
      <h2 class="black--text homepageTitle">{{ title }}</h2>
    </v-card-title>

    <v-card-text style="overflow-x: auto" class="px-0">
      <ItemGroup
        :items="activities"
        itemImgSrc="PictureUrl"
        itemText="EventTranslationName"
        :wrap="wrap"
        @select="activitySelected"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import uiHelpers from '@/shared/ui_helpers';
import { ACTIVITY_TYPES } from '@/shared/constants';
import doRequest, { addLog } from '@/api/dssRequest';
import ItemGroup from '@/components/generalComponents/uiComponents/ItemGroup';

export default {
  name: 'AllActivities',
  mixins: [uiHelpers],
  props: {
    /**
     * Wrap items instead of overflowing to the right
     */
    wrap: Boolean,
  },
  components: {
    ItemGroup,
  },
  data() {
    return {
      activities: [],
    };
  },
  computed: {
    pgrInfo() {
      return this.$store.getters['Account/partnerGroupDetails'];
    },
    title() {
      if (
        this.pgrInfo != null &&
        this.pgrInfo.EventFocusTitle != null &&
        this.pgrInfo.EventFocusTitle.trim() !== ''
      ) {
        return this.pgrInfo.EventFocusTitle.trim();
      }
      return this.$translate('ACTIVITIES_TITLE');
    },
  },
  mounted() {
    this.getActivities();
  },
  methods: {
    getActivities() {
      // Get events of types 'FlexEvent', 'Fixed', 'Repetitive', 'Tour'
      const payload = {
        IncludeAllPartnersInPartnerGroup: true,
        EventTypes: ACTIVITY_TYPES,
      };
      doRequest(
        (response) => {
          const unsortedArray = [];

          if (response.data.Events != null) {
            Object.entries(response.data.Events).forEach(([key, value]) =>
              unsortedArray.push({ key, ...value })
            );

            unsortedArray.sort((a, b) => {
              if (b.EventRanking > a.EventRanking) return 1;
              if (b.EventRanking < a.EventRanking) return -1;
              if (b.EventTranslationName > a.EventTranslationName) return -1;
              if (b.EventTranslationName < a.EventTranslationName) return 1;
              return 0;
            });

            this.activities = unsortedArray;
          }
        },
        () => {},
        'getEvents',
        'LocationsNode_ESE',
        payload,
        'GET'
      );
    },
    activitySelected(event) {
      // Add user interaction to log
      addLog(
        this.$store.getters['auth/userName'],
        event.EventId,
        'Event',
        'Home',
        -1
      );

      // Go to event details screen
      this.goToPage('EventDetails', { event_id: event.EventId });
    },
  },
};
</script>
